import{g as t}from"./generateUtilityClasses-4169ea48.js";import{g as e}from"./createTheme-c3f66f95.js";function r(t){return e("MuiListItemIcon",t)}var s=t("MuiListItemIcon",["root","alignItemsFlexStart"]);export{r as g,s as l};
